import { AxiosResponse } from 'axios';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { CUSTOMIZED_UNAUTHORIZED_STATUS_CODE } from '../../api/config/misc';
import { POST_LOGOUT_URL } from '../../constants/apiUrls';
import { useAuth } from '../../modules/profile/logic/auth';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

interface Input {
  refreshPage?: boolean;
  redirectToHome?: boolean;
  inactive?: boolean;
}

export const usePostLogout = (
  { refreshPage, redirectToHome, inactive }: Input = {
    refreshPage: false,
    redirectToHome: false,
    inactive: false,
  }
) => {
  const history = useHistory();
  const auth = useAuth();
  const queryClient = useQueryClient();
  let postLogout: () => Promise<AxiosResponse<void>>;
  if (inactive) {
    postLogout = async () =>
      axiosClient.post<void>(POST_LOGOUT_URL, null, { params: { inactive: true } });
  } else {
    postLogout = async () => axiosClient.post<void>(POST_LOGOUT_URL);
  }

  const handleLogout = () => {
    auth.signout();
    if (inactive) {
      auth.setUserSessionInactive();
    }
    queryClient.clear();
    if (refreshPage) {
      window.location.reload();
    } else if (redirectToHome) {
      history.push('/');
    }
  };

  return useCustomMutation(
    postLogout,
    {
      onSuccess: handleLogout,
      onError: (err) => {
        switch (err.response?.status) {
          case CUSTOMIZED_UNAUTHORIZED_STATUS_CODE:
          case 403:
            handleLogout();
            break;
          default:
            break;
        }
      },
    },
    false
  );
};
